import React,{useState} from 'react';
import { Link ,useNavigate} from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import LoadingForAll from '../../Pages/LoadingForAll';
import './LoginUser.css'
import { useUser } from '../../store/UserContext';

function LoginUser() {
    const navigate = useNavigate()
    const [email,setEmail] = useState('')
    const [password,setPassword] = useState('')
    const [loginErr,setLoginErr] = useState('')
    const [load,setLoad] = useState(false)
    
    const handleSubmit=async(e)=>{
        e.preventDefault()
        setLoginErr('')
        setLoad(true)

        try{
            const auth=getAuth()
            await signInWithEmailAndPassword(auth,email,password)
            navigate('/')
        }catch(error){
            setLoginErr(error.message)
        }finally{
            setLoad(false)
        }
    }
    
const getErrorMessage = (code) => {
    switch (code) {
        case 'auth/invalid-email':
            return 'Invalid email address';
        case 'auth/user-disabled':
            return 'Account disabled';
        case 'auth/user-not-found':
            return 'No account found with this email';
        case 'auth/wrong-password':
            return 'Incorrect password';
        case 'auth/too-many-requests':
            return 'Too many attempts. Try again later';
        default:
            return 'Login failed. Please try again';
    }
};
  return (
<section className="vh-100">
      <div className="container-fluid h-custom">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-md-9 col-lg-6 col-xl-5">
            <img 
              src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
              className="img-fluid" 
              alt="Sample" 
            />
          </div>
          <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
            <form onSubmit={handleSubmit}>
              <div className="divider d-flex align-items-center my-4">
                <p className="text-center fw-bold mx-3 mb-0" style={{fontSize: '35px', color: 'blue'}}>
                  Login
                </p>
              </div>
              {loginErr&&<div>{loginErr}</div>}
              {/* Name input */}
              <div className="form-outline mb-4">
              <label className="form-label" htmlFor="form3Example3">Email</label>
                <input 
                  type="text" 
                  id="form3Example3" 
                  className="form-control form-control-lg" 
                  name="Email"
                  value={email}
                  onChange={(e)=>setEmail(e.target.value)}
                  placeholder="Enter your name" 
                />
                
              </div>

               {/* password input */}
              <div className="form-outline mb-4">
              <label className="form-label" htmlFor="form3Example3">Password</label>
                <input 
                  type="number" 
                  id="form3Example3" 
                  className="form-control form-control-lg" 
                  name="Password"
                  value={password}
                  onChange={(e)=>setPassword(e.target.value)}
                  placeholder="Enter your phone number" 
                />
              
              </div>

              

              <div className="d-flex justify-content-between align-items-center">
                
                <button 
                  type="submit" 
                  className="btn btn-primary btn-lg"
                  style={{paddingLeft: '2.5rem', paddingRight: '2.5rem'}}
                >
                  Login
                </button>
                
      {load&& <LoadingForAll title='Creating your account...'></LoadingForAll>}
                <p className="small fw-bold mt-2 pt-1 mb-0" style={{fontSize: '16px'}}>
                  Don't have an account.
                  <Link to="/signup" className="link-danger"  style={{textDecoration: 'underline',color:'blue'}}>Signup?</Link>
                </p>
                
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LoginUser